import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { HierarchyCreatePayload } from 'api/actions/hierarchy-create/hierarchy-create-payload';
import { HierarchyCreatePathParameters } from 'api/actions/hierarchy-create/hierarchy-create-path-parameters';
import { HierarchyCreateResponse } from 'api/actions/hierarchy-create/hierarchy-create-response';

type HierarchyCreateQueryParameters = Record<string, any>;

/**
 * The path of the HierarchyCreate action.
 */
export const hierarchyCreateActionPath = new SweetPath<keyof HierarchyCreatePathParameters>('/api/hierarchy/create', {
  path: '{param}',
});

/**
 * Creates a contextualized HierarchyCreate actions.
 */
export default function createHierarchyCreateAction(axios: AxiosInstance) {
  return function hierarchyCreateAction({
    headers = {},
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    query?: HierarchyCreateQueryParameters;
    payload: HierarchyCreatePayload;
  }) {
    const path = hierarchyCreateActionPath.original;

    return axios.request<HierarchyCreateResponse, HierarchyCreateResponse>({
      method: 'post',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
